export const ENIGME_SETS = {
  A1: [
    {
      id: 'enigmes-animaux',
      title: 'Les animaux (Énigmes + Expression orale)',
      finalTask: 'Mon animal préféré est le/la ____ parce que ____.',
      finalExamples: [
        "Mon animal préféré est le chat parce qu'il est mignon.",
        "J'aime le cheval parce qu'il court vite.",
      ],
      questions: [
        {
          clue: "Je suis grand.\nJe dis « meuh ».\nJe donne du lait.",
          emoji: '🐮', answer: 'La vache',
          oral: ['Elle est grande ou petite ?', 'Où elle vit ?', 'Tu aimes le lait ?'],
        },
        {
          clue: "J'ai deux ailes.\nJe vole.\nJe chante le matin.",
          emoji: '🐦', answer: "L'oiseau",
          oral: ['Il a combien de pattes ?', 'Il vole ?', 'De quelle couleur est ton oiseau préféré ?'],
        },
        {
          clue: "Je n'ai pas de jambes.\nJe rampe.\nJ'ai peur des gens… ou les gens ont peur de moi !",
          emoji: '🐍', answer: 'Le serpent',
          oral: ['Il est dangereux ?', 'Il est grand ou petit ?', 'Tu aimes les serpents ?'],
        },
        {
          clue: "Je vis dans la mer.\nJe nage vite.\nJe ne parle pas, mais je fais des bulles.",
          emoji: '🐠', answer: 'Le poisson',
          oral: ['Il vit où ?', 'Tu manges du poisson ?', 'Il est de quelle couleur ?'],
        },
        {
          clue: "Je suis petit.\nJ'ai de longues oreilles.\nJ'aime les carottes.",
          emoji: '🐰', answer: 'Le lapin',
          oral: ['Il court vite ?', 'Tu aimes les lapins ?', 'De quelle couleur il est ?'],
        },
        {
          clue: "Je suis très grand.\nJ'ai une trompe.\nJe vis en Afrique ou en Inde.",
          emoji: '🐘', answer: "L'éléphant",
          oral: ['Il est grand ou petit ?', 'Il a une longue trompe ?', 'Tu veux voir un éléphant au zoo ?'],
        },
        {
          clue: "Je suis noir et blanc.\nJe ne vole pas.\nJe marche sur la glace.",
          emoji: '🐧', answer: 'Le pingouin',
          oral: ['Il fait chaud ou froid chez le pingouin ?', 'Il nage ?', 'Tu aimes la neige ?'],
        },
        {
          clue: "Je vis à la ferme.\nJe dis « cocorico ».\nJe chante le matin.",
          emoji: '🐓', answer: 'Le coq',
          oral: ['Il vit où ?', 'Il fait quel bruit ?', 'Tu as déjà vu un coq ?'],
        },
        {
          clue: "Je suis petit.\nJe vole.\nJe fais « bzzz » et j'aime les fleurs.",
          emoji: '🐝', answer: "L'abeille",
          oral: ['Elle est dangereuse ?', 'Elle fait du miel ?', 'Tu as peur des abeilles ?'],
        },
        {
          clue: "Je suis fort.\nJ'ai une crinière.\nJe suis le roi des animaux.",
          emoji: '🦁', answer: 'Le lion',
          oral: ['Il est dangereux ?', 'Il court vite ?', 'Tu veux le voir au zoo ?'],
        },
      ],
    },
    {
      id: 'enigmes-objets-quotidien',
      title: 'Objets & Quotidien (Énigmes)',
      finalTask: 'Décris un objet de ta maison : Il est ____, il sert à ____.',
      finalExamples: [
        'Il est grand, il sert à regarder des films. (La télévision)',
        'Il est petit, il sert à écrire. (Le crayon)',
      ],
      questions: [
        {
          clue: "Je suis petit et jaune.\nJe dis « piou piou ».\nJe vis avec la poule.\nJe suis un bébé animal.",
          emoji: '🐥', answer: 'Le poussin',
        },
        {
          clue: "Je suis petit.\nOn écrit avec moi.\nJe suis jaune ou noir.\nJ'ai une mine.",
          emoji: '✏️', answer: 'Le crayon',
        },
        {
          clue: "Je coupe le papier.\nJ'ai deux petits bras.\nOn m'utilise à l'école.",
          emoji: '✂️', answer: 'Les ciseaux',
        },
        {
          clue: "J'efface les erreurs.\nJe suis blanche ou rose.\nJe suis dans la trousse.",
          emoji: '🧽', answer: 'La gomme',
        },
        {
          clue: "J'éclaire la pièce.\nJe suis dans la chambre.\nOn m'allume la nuit.",
          emoji: '💡', answer: 'La lampe',
        },
        {
          clue: "On s'assoit dessus.\nJ'ai quatre pieds.\nJe suis dans la maison.",
          emoji: '💺', answer: 'La chaise',
        },
        {
          clue: "On mange dessus.\nJe suis dans la cuisine.\nJe suis plate.",
          emoji: '🍽️', answer: 'La table',
        },
        {
          clue: "On regarde l'heure avec moi.\nJ'ai deux aiguilles.\nJe suis sur le mur.",
          emoji: '🕰️', answer: "L'horloge",
        },
        {
          clue: "Je garde les choses.\nOn m'ouvre et on me ferme.\nJe vais à l'école avec toi.",
          emoji: '🎒', answer: 'Le sac',
        },
        {
          clue: "On me lit.\nJ'ai beaucoup de pages.\nJe raconte des histoires.",
          emoji: '📖', answer: 'Le livre',
        },
        {
          clue: "Je montre ton visage.\nTu te regardes dedans.\nJe suis dans la salle de bain.",
          emoji: '🪞', answer: 'Le miroir',
        },
        {
          clue: "Je fais de la musique.\nJ'ai des touches.\nJe suis grand et noir ou blanc.",
          emoji: '🎹', answer: 'Le piano',
        },
        {
          clue: "Je fais du bruit.\nOn écoute la musique avec moi.\nJe suis dans la poche.",
          emoji: '📱', answer: 'Le téléphone',
        },
        {
          clue: "Je suis dans la classe.\nLe professeur écrit dessus.\nJe suis grand et noir ou blanc.",
          emoji: '🧑‍🏫', answer: 'Le tableau',
        },
        {
          clue: "Je garde les aliments au froid.\nJe suis dans la cuisine.\nOn m'ouvre souvent.",
          emoji: '❄️', answer: 'Le réfrigérateur',
        },
        {
          clue: "Je suis petit.\nJe montre l'heure.\nJe suis sur le poignet.",
          emoji: '⌚', answer: 'La montre',
        },
        {
          clue: "On boit dedans.\nJe suis en verre ou en plastique.\nJe peux être transparent.",
          emoji: '🥛', answer: 'Le verre',
        },
        {
          clue: "On ouvre les portes avec moi.\nJe suis petite.\nJe vais avec une serrure.",
          emoji: '🔑', answer: 'La clé',
        },
        {
          clue: "Je suis dans le salon.\nOn regarde des films avec moi.\nJ'ai un écran.",
          emoji: '📺', answer: 'La télévision',
        },
        {
          clue: "Je chauffe la nourriture.\nJe suis rapide.\nJe suis dans la cuisine.",
          emoji: '🔥', answer: 'Le micro-ondes',
        },
        {
          clue: "On me porte.\nJe protège du soleil.\nJe suis sur les yeux.",
          emoji: '😎', answer: 'Les lunettes de soleil',
        },
      ],
    },
    {
      id: 'enigmes-verbes-actions',
      title: 'Devinettes – Verbes / Actions',
      finalTask: "Dis trois choses que tu fais aujourd'hui : Aujourd'hui, je ____.",
      finalExamples: [
        "Aujourd'hui, je lis un livre, je mange une pizza et je marche au parc.",
        "Aujourd'hui, je chante, je dessine et je regarde un film.",
      ],
      questions: [
        {
          clue: "Je lis un livre.\nJe regarde les mots.",
          emoji: '📖', answer: 'Lire',
          oral: ['Tu aimes lire ?', 'Tu lis en français ?'],
        },
        {
          clue: "Je prends un crayon.\nJe fais des lettres.",
          emoji: '✍️', answer: 'Écrire',
          oral: ['Tu écris souvent ?', 'Tu écris en français ou en anglais ?'],
        },
        {
          clue: "J'ai faim.\nJe prends une pizza.",
          emoji: '🍕', answer: 'Manger',
          oral: ['Tu aimes manger ?', 'Quel est ton plat préféré ?'],
        },
        {
          clue: "J'ai soif.\nJe prends de l'eau.",
          emoji: '💧', answer: 'Boire',
          oral: ["Tu bois de l'eau ou du jus ?", "Combien de verres d'eau tu bois ?"],
        },
        {
          clue: "J'écoute la musique.\nJ'entends un son.",
          emoji: '🎧', answer: 'Écouter',
          oral: ['Tu écoutes de la musique ?', 'Quel type de musique tu préfères ?'],
        },
        {
          clue: "Je parle avec un ami.",
          emoji: '🗣️', answer: 'Parler',
          oral: ['Tu parles français ?', 'Avec qui tu parles le plus ?'],
        },
        {
          clue: "Je bouge mes jambes vite.",
          emoji: '🏃', answer: 'Courir',
          oral: ['Tu aimes courir ?', 'Tu fais du sport ?'],
        },
        {
          clue: "Je suis fatigué.\nJe ferme les yeux.",
          emoji: '😴', answer: 'Dormir',
          oral: ["Tu dors combien d'heures ?", 'Tu dors tôt ou tard ?'],
        },
        {
          clue: "Je prends de l'eau.\nJe nettoie mes mains.",
          emoji: '🧼', answer: 'Se laver',
          oral: ['Tu te laves les mains souvent ?', 'Quand tu te laves ?'],
        },
        {
          clue: "Je vais d'un endroit à un autre.",
          emoji: '🚶', answer: 'Marcher',
          oral: ['Tu marches beaucoup ?', "Tu marches à l'école ?"],
        },
        {
          clue: "Je prends mon téléphone.\nJe fais un appel.",
          emoji: '📞', answer: 'Téléphoner',
          oral: ['Tu téléphones souvent ?', 'À qui tu téléphones ?'],
        },
        {
          clue: "J'étudie pour un examen.",
          emoji: '📝', answer: 'Apprendre',
          oral: ['Tu aimes apprendre le français ?', "Tu étudies combien d'heures ?"],
        },
        {
          clue: "J'utilise de l'argent dans un magasin.",
          emoji: '🛍️', answer: 'Acheter',
          oral: ['Tu aimes acheter des vêtements ?', 'Tu achètes en ligne ou en magasin ?'],
        },
        {
          clue: "Je donne quelque chose à quelqu'un.",
          emoji: '🎁', answer: 'Donner',
          oral: ['Tu donnes des cadeaux ?', 'À qui tu donnes souvent ?'],
        },
        {
          clue: "Je reçois un cadeau.",
          emoji: '🎀', answer: 'Recevoir',
          oral: ['Tu aimes recevoir des cadeaux ?', 'Quel cadeau tu veux ?'],
        },
        {
          clue: "Je mets mes vêtements le matin.",
          emoji: '👕', answer: "S'habiller",
          oral: ["Tu t'habilles vite ou lentement ?", 'Tu aimes les vêtements ?'],
        },
        {
          clue: "Je me déplace sur un vélo.",
          emoji: '🚲', answer: 'Faire du vélo',
          oral: ['Tu fais du vélo ?', 'Où tu fais du vélo ?'],
        },
        {
          clue: "Je fais un dessin.",
          emoji: '🎨', answer: 'Dessiner',
          oral: ['Tu aimes dessiner ?', "Qu'est-ce que tu dessines ?"],
        },
        {
          clue: "Je chante une chanson.",
          emoji: '🎤', answer: 'Chanter',
          oral: ['Tu aimes chanter ?', 'Tu chantes en français ?'],
        },
        {
          clue: "Je regarde un film.",
          emoji: '🎬', answer: 'Regarder',
          oral: ['Tu regardes des films ?', 'Quel film tu aimes ?'],
        },
      ],
    },
  ],
  A2: [
    {
      id: 'enigmes-objets-quotidien-a2',
      title: 'Devinettes – Objets du quotidien',
      finalTask: "Décris un objet que tu utilises chaque jour : J'utilise ____ parce que ____.",
      finalExamples: [
        "J'utilise un parapluie parce qu'il pleut souvent dans ma ville.",
        "J'utilise un réveil parce que je dois me lever tôt.",
      ],
      questions: [
        {
          clue: "Je suis un accessoire d'hiver.\nOn ne me porte pas sur la tête, mais autour du cou.\nSans moi, tu peux avoir très froid.",
          emoji: '🧣', answer: 'Une écharpe',
          oral: ["Tu portes une écharpe en hiver ?", "Tu préfères le froid ou le chaud ?"],
        },
        {
          clue: "On me porte à la maison, surtout quand on veut être à l'aise.\nJe ne suis pas faite pour sortir dehors.",
          emoji: '🥿', answer: 'Des pantoufles',
          oral: ['Tu portes des pantoufles chez toi ?', 'Tu préfères être pieds nus ou en pantoufles ?'],
        },
        {
          clue: "Je fais du bruit tôt le matin.\nMon objectif est de te réveiller, même si tu ne veux pas.",
          emoji: '⏰', answer: 'Un réveil',
          oral: ['À quelle heure tu te réveilles ?', 'Tu aimes te lever tôt ?'],
        },
        {
          clue: "Je peux être très épais ou très simple.\nOn me lit pour apprendre ou pour se divertir.",
          emoji: '📚', answer: 'Un livre',
          oral: ['Tu lis souvent ?', 'Quel type de livre tu préfères ?'],
        },
        {
          clue: "On m'utilise quand il pleut.\nJe protège le haut du corps, mais pas les pieds.",
          emoji: '☂️', answer: 'Un parapluie',
          oral: ['Tu aimes la pluie ?', 'Tu préfères la pluie ou le soleil ?'],
        },
        {
          clue: "Je suis petit mais très important.\nJe garde de l'argent et parfois des cartes.",
          emoji: '👛', answer: 'Un portefeuille',
          oral: ['Tu utilises un portefeuille ou ton téléphone ?', 'Tu fais souvent du shopping ?'],
        },
        {
          clue: "Sans moi, ton téléphone ne fonctionne plus longtemps.\nJe suis souvent branché à une prise.",
          emoji: '🔌', answer: 'Un chargeur',
          oral: ['Ton téléphone se décharge vite ?', 'Tu utilises ton téléphone souvent ?'],
        },
        {
          clue: "Je suis dans la cuisine.\nJe fais du froid pour conserver les aliments.",
          emoji: '❄️', answer: 'Un réfrigérateur',
          oral: ["Qu'est-ce qu'il y a dans ton frigo ?", 'Tu cuisines souvent ?'],
        },
        {
          clue: "Tu me regardes le matin avant de sortir.\nJe te montre ton visage, mais je ne parle pas.",
          emoji: '🪞', answer: 'Un miroir',
          oral: ['Tu te regardes souvent dans le miroir ?', 'Tu te prépares vite le matin ?'],
        },
        {
          clue: "Je suis un objet utile à l'école ou à la maison.\nJe coupe, mais je ne suis pas dangereux si on m'utilise bien.",
          emoji: '✂️', answer: 'Des ciseaux',
          oral: ['Tu utilises des ciseaux souvent ?', 'Pour quoi faire ?'],
        },
      ],
    },
    {
      id: 'enigmes-objets-modernes-a2',
      title: 'Devinettes – Objets modernes & quotidien',
      finalTask: "Quel objet moderne est le plus important pour toi ? Je ne peux pas vivre sans ____ parce que ____.",
      finalExamples: [
        'Je ne peux pas vivre sans mon téléphone parce que je communique avec tout le monde.',
        'Je ne peux pas vivre sans mes écouteurs parce que la musique me détend.',
      ],
      questions: [
        {
          clue: "Je suis un objet très utilisé aujourd'hui.\nJe peux contenir des photos, des messages et des applications.\nTu me consultes souvent, parfois sans raison.\nJe sonne quand quelqu'un veut te parler.",
          emoji: '📱', answer: 'Le téléphone',
          oral: ['Combien de temps passes-tu sur ton téléphone chaque jour ?', "À quoi l'utilises-tu le plus ?"],
        },
        {
          clue: "Je suis petit, mais très important.\nJe garde ton argent et tes cartes.\nQuand tu sors sans moi, tu peux avoir des difficultés.",
          emoji: '👛', answer: 'Le portefeuille',
          oral: ['Tu fais attention à ton portefeuille ?', "Qu'est-ce que tu gardes toujours dedans ?"],
        },
        {
          clue: "Je suis utile surtout quand il pleut.\nJe m'ouvre et se ferme facilement.\nLe vent peut parfois me casser.",
          emoji: '☂️', answer: 'Le parapluie',
          oral: ['Tu penses toujours à prendre ton parapluie ?', 'Tu préfères les jours de pluie ou de soleil ?'],
        },
        {
          clue: "Je te permets d'écouter de la musique sans déranger les autres.\nJe vais dans les oreilles et je peux être sans fil.\nTu m'utilises souvent dans les transports.",
          emoji: '🎧', answer: 'Les écouteurs',
          oral: ['Tu écoutes de la musique tous les jours ?', 'Où écoutes-tu le plus de musique ?'],
        },
        {
          clue: "Je suis porté au poignet.\nJe ne montre pas seulement l'heure, mais parfois aussi ton activité physique.\nJe peux être simple ou connectée.",
          emoji: '⌚', answer: 'La montre / montre connectée',
          oral: ['Tu portes une montre tous les jours ?', 'Tu préfères une montre classique ou connectée ?'],
        },
        {
          clue: "Tu écris sur moi, mais je ne suis pas du papier.\nOn peut m'effacer facilement après utilisation.\nJe suis souvent utilisé à l'école ou au bureau.",
          emoji: '🧑‍🏫', answer: 'Le tableau blanc',
          oral: ['Tu préfères écrire sur un tableau ou sur papier ?', 'Tu prends souvent des notes en classe ?'],
        },
        {
          clue: "Je suis dans la cuisine.\nJe garde les aliments au froid pour les conserver plus longtemps.\nOn m'ouvre plusieurs fois par jour.",
          emoji: '❄️', answer: 'Le réfrigérateur',
          oral: ['Qu\'est-ce que tu mets toujours dans ton frigo ?', 'Tu fais les courses souvent ?'],
        },
        {
          clue: "Je fais du bruit quand je fonctionne.\nJe nettoie le sol rapidement.\nJe suis très utile dans les maisons avec des animaux.",
          emoji: '🧹', answer: "L'aspirateur",
          oral: ['Tu fais le ménage souvent ?', 'Tu préfères utiliser un aspirateur ou balayer ?'],
        },
        {
          clue: "Je suis un appareil pour lire, mais je ne suis pas un livre papier.\nTu peux lire même dans le noir sans problème.\nJe peux contenir beaucoup d'histoires sans être lourd.",
          emoji: '📖', answer: 'La liseuse',
          oral: ['Tu préfères lire sur écran ou sur papier ?', 'Tu lis souvent avant de dormir ?'],
        },
        {
          clue: "Je suis personnel.\nTu écris dedans pour garder tes idées, tes souvenirs ou tes émotions.\nCertaines personnes m'utilisent tous les jours.",
          emoji: '📓', answer: 'Le journal / cahier personnel',
          oral: ['Tu écris parfois tes pensées ?', "Qu'est-ce qui t'aide à te sentir mieux quand tu es stressé ?"],
        },
      ],
    },
    {
      id: 'enigmes-objets-quotidien-v2-a2',
      title: 'Devinettes – Objets du quotidien (v2)',
      finalTask: "Décris un objet important pour toi : J'ai besoin de ____ parce que ____.",
      finalExamples: [
        "J'ai besoin de mon parapluie parce qu'il pleut souvent.",
        "J'ai besoin de mon chargeur parce que j'utilise beaucoup mon téléphone.",
      ],
      questions: [
        {
          clue: "Quand il fait très froid en hiver, tu me mets autour du cou pour te protéger du vent.\nJe suis souvent en laine.",
          emoji: '🧣', answer: 'Une écharpe',
          oral: ['Tu portes souvent une écharpe en hiver ?', 'Tu préfères le froid ou la chaleur ?'],
        },
        {
          clue: "Tu me portes à la maison pour être confortable.\nJe ne suis pas faite pour sortir dehors.",
          emoji: '🥿', answer: 'Des pantoufles',
          oral: ["Qu'est-ce que tu portes à la maison ?", 'Tu préfères être confortable ou élégant ?'],
        },
        {
          clue: "Je sonne le matin pour te réveiller.\nParfois, tu veux m'arrêter et continuer à dormir.",
          emoji: '⏰', answer: 'Un réveil',
          oral: ['À quelle heure tu te réveilles ?', 'Tu aimes te lever tôt ?'],
        },
        {
          clue: "Je suis composé de nombreuses pages.\nTu peux apprendre beaucoup de choses avec moi.",
          emoji: '📚', answer: 'Un livre',
          oral: ['Tu lis souvent ?', 'Quel type de livres tu préfères ?'],
        },
        {
          clue: "Quand il pleut, tu m'utilises pour rester sec.\nJe peux être pliable ou grand.",
          emoji: '☂️', answer: 'Un parapluie',
          oral: ['Tu oublies souvent ton parapluie ?', 'Tu aimes marcher sous la pluie ?'],
        },
        {
          clue: "Je garde ton argent et tes cartes en sécurité.\nTu me mets dans ton sac ou ta poche.",
          emoji: '👛', answer: 'Un portefeuille',
          oral: ['Tu fais attention à tes affaires ?', "Tu utilises plus l'argent ou la carte ?"],
        },
        {
          clue: "Sans moi, ton téléphone ne fonctionne plus longtemps.\nTu me branches pour donner de l'énergie.",
          emoji: '🔌', answer: 'Un chargeur',
          oral: ["Ton téléphone a souvent besoin d'être chargé ?", 'Tu utilises beaucoup ton téléphone ?'],
        },
        {
          clue: "Je suis dans la cuisine.\nJe garde les aliments au froid pour les conserver.",
          emoji: '❄️', answer: 'Un réfrigérateur',
          oral: ["Qu'est-ce qu'il y a dans ton frigo ?", 'Tu cuisines souvent ?'],
        },
        {
          clue: "Tu me regardes pour voir ton visage.\nJe suis souvent dans la salle de bain.",
          emoji: '🪞', answer: 'Un miroir',
          oral: ['Tu te regardes souvent dans le miroir ?', 'Tu fais attention à ton apparence ?'],
        },
        {
          clue: "Tu m'utilises pour couper du papier ou du carton.\nJe suis très utile à l'école.",
          emoji: '✂️', answer: 'Des ciseaux',
          oral: ['Tu utilises souvent des ciseaux ?', 'Tu aimes les activités manuelles ?'],
        },
      ],
    },
    {
      id: 'enigmes-verbes-actions-a2',
      title: 'Devinettes – Verbes et actions quotidiennes',
      finalTask: "Décris ta routine : Le matin, je ____, puis je ____, et après je ____.",
      finalExamples: [
        "Le matin, je me lave, puis je m'habille, et après je mange.",
        "Le matin, je me réveille, puis je marche, et après je cuisine.",
      ],
      questions: [
        {
          clue: "Le matin, tu fais cette action pour nettoyer ton visage et te réveiller.",
          emoji: '🧼', answer: 'Se laver',
          oral: ['Quelle est ta routine du matin ?', 'Tu préfères la douche ou te laver rapidement ?'],
        },
        {
          clue: "Avant de sortir, tu fais cette action pour choisir tes vêtements.",
          emoji: '👕', answer: "S'habiller",
          oral: ["Combien de temps prends-tu pour t'habiller ?", 'Tu choisis tes vêtements rapidement ?'],
        },
        {
          clue: "Tu fais cette action pour te déplacer sans transport, avec tes pieds.",
          emoji: '🚶', answer: 'Marcher',
          oral: ['Tu marches beaucoup dans la journée ?', 'Tu préfères marcher ou prendre le bus ?'],
        },
        {
          clue: "Tu fais cette action plusieurs fois par jour quand tu as faim.",
          emoji: '🍽️', answer: 'Manger',
          oral: ['Tu manges à heures régulières ?', 'Quel est ton plat préféré ?'],
        },
        {
          clue: "Tu fais cette activité pour rester en bonne santé.",
          emoji: '🏃', answer: 'Faire du sport',
          oral: ['Tu fais du sport régulièrement ?', 'Quel sport tu préfères ?'],
        },
        {
          clue: "Quand tu es en retard, tu fais cette action pour aller plus vite.",
          emoji: '⚡', answer: 'Se dépêcher',
          oral: ['Tu es souvent en retard ?', 'Tu es une personne organisée ?'],
        },
        {
          clue: "Quand tu veux communiquer avec quelqu'un sur ton téléphone, tu fais cette action.",
          emoji: '💬', answer: 'Envoyer (un message)',
          oral: ['Tu envoies beaucoup de messages ?', "Tu préfères écrire ou appeler ?"],
        },
        {
          clue: "Quand tu as besoin d'aide, tu fais cette action avec ton téléphone.",
          emoji: '📞', answer: 'Appeler',
          oral: ['Tu appelles souvent tes amis ?', "Tu préfères appeler ou envoyer un message ?"],
        },
        {
          clue: "Quand tu étudies, tu fais cette action avec un livre ou un texte.",
          emoji: '📖', answer: 'Lire',
          oral: ['Tu lis tous les jours ?', 'Tu préfères lire le matin ou le soir ?'],
        },
        {
          clue: "Le soir, quand tu es fatigué, tu fais cette action dans ton lit.",
          emoji: '😴', answer: 'Dormir',
          oral: ["Combien d'heures tu dors ?", 'Tu dors facilement ?'],
        },
        {
          clue: "Quand tu vas au supermarché pour acheter de la nourriture, tu fais cette action.",
          emoji: '🛒', answer: 'Faire les courses',
          oral: ['Tu fais les courses souvent ?', 'Tu préfères les magasins ou les courses en ligne ?'],
        },
        {
          clue: "Quand tu rencontres quelqu'un, tu fais cette action pour dire bonjour.",
          emoji: '👋', answer: 'Saluer',
          oral: ['Comment tu salues tes amis ?', 'Tu es plutôt formel ou informel ?'],
        },
        {
          clue: "Quand tu arrives chez toi, tu fais cette action avec la porte.",
          emoji: '🚪', answer: 'Ouvrir',
          oral: ['Tu oublies parfois tes clés ?', 'Tu vis seul ou avec ta famille ?'],
        },
        {
          clue: "Quand tu as beaucoup d'objets, tu fais cette action pour les transporter.",
          emoji: '🎒', answer: 'Porter',
          oral: ['Tu portes souvent des sacs lourds ?', 'Tu préfères sac à dos ou sac à main ?'],
        },
        {
          clue: "Quand tu veux écouter de la musique, tu fais cette action.",
          emoji: '🎧', answer: 'Écouter',
          oral: ['Tu écoutes de la musique tous les jours ?', 'Quel style de musique tu préfères ?'],
        },
        {
          clue: "Quand tu te déplaces vers un endroit, tu fais cette action.",
          emoji: '🗺️', answer: 'Aller',
          oral: ['Où vas-tu le week-end ?', 'Tu aimes sortir ?'],
        },
        {
          clue: "Quand tu prépares un repas, tu fais cette action.",
          emoji: '🍳', answer: 'Cuisiner',
          oral: ['Tu cuisines souvent ?', 'Quel plat sais-tu faire ?'],
        },
        {
          clue: "Quand tu racontes ta journée à quelqu'un, tu fais cette action.",
          emoji: '🗣️', answer: 'Raconter',
          oral: ['Tu parles souvent de ta journée ?', 'À qui tu racontes tes expériences ?'],
        },
      ],
    },
  ],
  B1: [
    {
      id: 'enigmes-actions-reflexion-b1',
      title: 'Actions & réflexion',
      finalTask: "Utilise deux de ces verbes dans une phrase : Je ____ quand ____.",
      finalExamples: [
        "Je m'excuse quand je fais une erreur.",
        "J'analyse la situation quand je ne comprends pas.",
      ],
      questions: [
        { clue: "Je change mon opinion après avoir entendu de bons arguments.\nQuel verbe ?", emoji: '🤔', answer: 'Admettre / reconnaître' },
        { clue: "Je prends le temps de bien comprendre une situation avant d'agir.", emoji: '🔍', answer: 'Analyser' },
        { clue: "Je fais cela régulièrement pour améliorer mes compétences.", emoji: '🏋️', answer: "S'entraîner / pratiquer" },
        { clue: 'Je dis "pardon" pour une erreur.', emoji: '🙏', answer: "S'excuser" },
        { clue: "Je ne suis pas d'accord, mais je parle poliment.", emoji: '🗣️', answer: 'Exprimer son désaccord' },
        { clue: "Je donne une solution à quelqu'un.", emoji: '💡', answer: 'Conseiller' },
        { clue: "Je fais ce que j'ai promis.", emoji: '🤝', answer: 'Respecter (une promesse)' },
        { clue: "Je termine un travail avant la date limite.", emoji: '⏰', answer: 'Respecter un délai / finaliser' },
        { clue: "Je choisis la meilleure option.", emoji: '⚖️', answer: 'Décider' },
        { clue: "Je partage mes idées dans une discussion.", emoji: '💬', answer: 'Participer / intervenir' },
      ],
    },
    {
      id: 'enigmes-actions-sociales-b1',
      title: 'Actions sociales',
      finalTask: "Décris une action sociale que tu fais : Je ____ parce que ____.",
      finalExamples: [
        "Je m'engage parce que je veux aider les autres.",
        "Je collabore parce que le travail en équipe est plus efficace.",
      ],
      questions: [
        { clue: "J'aide quelqu'un sans qu'il demande.", emoji: '🤲', answer: 'Proposer' },
        { clue: "Je calme une dispute.", emoji: '🕊️', answer: 'Intervenir' },
        { clue: "Je m'implique dans un problème collectif.", emoji: '✊', answer: "S'engager" },
        { clue: "J'accepte les différences.", emoji: '🌍', answer: 'Respecter' },
        { clue: "Je partage les tâches équitablement.", emoji: '⚖️', answer: 'Répartir' },
        { clue: "Je participe à une bonne cause.", emoji: '❤️', answer: 'Contribuer' },
        { clue: "Je prépare une réunion.", emoji: '📋', answer: 'Organiser' },
        { clue: "Je défends quelqu'un injustement.", emoji: '🛡️', answer: 'Soutenir' },
        { clue: "Je donne une idée pour améliorer quelque chose.", emoji: '📝', answer: 'Suggérer' },
        { clue: "Je travaille avec d'autres sur un projet.", emoji: '👥', answer: 'Collaborer' },
      ],
    },
    {
      id: 'enigmes-emotions-b1',
      title: 'Émotions',
      finalTask: "Décris une émotion que tu ressens souvent : Je ressens ____ quand ____.",
      finalExamples: [
        "Je ressens de l'impatience quand j'attends le bus.",
        "Je me réjouis quand je réussis un examen.",
      ],
      questions: [
        { clue: "Je continue même si c'est difficile.", emoji: '💪', answer: 'La persévérance' },
        { clue: "Je suis inquiet et stressé en même temps.", emoji: '😰', answer: "L'angoisse" },
        { clue: "Je cache ma colère.", emoji: '😶', answer: 'Se contenir' },
        { clue: "Je regrette ce que j'ai dit.", emoji: '😔', answer: 'La culpabilité' },
        { clue: "Je calme une personne stressée.", emoji: '🤗', answer: 'Rassurer' },
        { clue: "J'attends une réponse importante.", emoji: '⏳', answer: "L'impatience" },
        { clue: "Je suis très content.", emoji: '😊', answer: 'Se réjouir' },
        { clue: "Je suis stressé avant de parler en public.", emoji: '🎤', answer: 'Le trac' },
        { clue: "J'évite un conflit.", emoji: '☮️', answer: 'Apaiser' },
        { clue: "Je me sens traité injustement.", emoji: '😤', answer: 'La frustration' },
      ],
    },
    {
      id: 'enigmes-metiers-b1',
      title: 'Métiers',
      finalTask: "Quel métier t'intéresse ? Je voudrais être ____ parce que ____.",
      finalExamples: [
        "Je voudrais être architecte parce que j'aime le design.",
        "Je voudrais être chef parce que j'adore cuisiner.",
      ],
      questions: [
        { clue: "Je soigne les patients.", emoji: '🏥', answer: 'Infirmier / infirmière' },
        { clue: "Je cuisine dans un restaurant.", emoji: '👨‍🍳', answer: 'Chef' },
        { clue: "Je donne des conseils financiers.", emoji: '💰', answer: 'Conseiller financier' },
        { clue: "J'enseigne aux élèves.", emoji: '👩‍🏫', answer: 'Professeur' },
        { clue: "Je répare les tuyaux.", emoji: '🔧', answer: 'Plombier' },
        { clue: "Je dessine des bâtiments.", emoji: '🏛️', answer: 'Architecte' },
        { clue: "Je contrôle la sécurité à l'aéroport.", emoji: '🛂', answer: 'Agent de sécurité' },
        { clue: "Je crée des publicités.", emoji: '📢', answer: 'Marketeur' },
        { clue: "Je fais respecter la loi.", emoji: '👮', answer: 'Policier' },
        { clue: "Je soigne les dents.", emoji: '🦷', answer: 'Dentiste' },
      ],
    },
    {
      id: 'enigmes-pays-culture-b1',
      title: 'Pays & culture',
      finalTask: "Quel pays veux-tu visiter ? Je veux visiter ____ parce que ____.",
      finalExamples: [
        "Je veux visiter l'Italie parce que j'adore les pâtes et l'art.",
        "Je veux visiter le Japon parce que la culture est fascinante.",
      ],
      questions: [
        { clue: "Je suis un pays connu pour les pâtes.", emoji: '🍝', answer: 'Italie' },
        { clue: "Je suis connu pour le sirop d'érable.", emoji: '🍁', answer: 'Canada' },
        { clue: "On y trouve la Tour Eiffel.", emoji: '🗼', answer: 'France' },
        { clue: "Je suis célèbre pour mes pyramides.", emoji: '🏛️', answer: 'Égypte' },
        { clue: "Je suis très long en Amérique du Sud.", emoji: '🌎', answer: 'Chili' },
        { clue: "Je suis connu pour Bollywood.", emoji: '🎬', answer: 'Inde' },
        { clue: "Je parle portugais en Amérique du Sud.", emoji: '🌴', answer: 'Brésil' },
        { clue: "J'ai des kangourous.", emoji: '🦘', answer: 'Australie' },
        { clue: "Big Ben est chez moi.", emoji: '🕰️', answer: 'Royaume-Uni' },
        { clue: "Je suis froid avec des volcans.", emoji: '🌋', answer: 'Islande' },
      ],
    },
    {
      id: 'enigmes-temps-conjugaison-b1',
      title: 'Temps & conjugaison',
      finalTask: "Utilise un temps verbal dans une phrase complète.",
      finalExamples: [
        "Quand j'étais petit, je jouais dans le jardin. (Imparfait)",
        "Si j'avais le temps, je voyagerais plus. (Conditionnel)",
      ],
      questions: [
        { clue: '"Quand j\'étais petite…"', emoji: '📖', answer: 'Imparfait' },
        { clue: '"Demain, je partirai…"', emoji: '🔮', answer: 'Futur simple' },
        { clue: '"Il faut que tu viennes…"', emoji: '📌', answer: 'Subjonctif' },
        { clue: '"Après avoir mangé…"', emoji: '🍽️', answer: 'Infinitif passé' },
        { clue: '"Si j\'avais le temps…"', emoji: '💭', answer: 'Conditionnel' },
        { clue: '"Je viens de finir…"', emoji: '✅', answer: 'Passé récent' },
        { clue: '"Je suis en train de manger…"', emoji: '🍴', answer: 'Présent progressif' },
        { clue: '"Quand tu auras fini…"', emoji: '⏩', answer: 'Futur antérieur' },
        { clue: '"Il a dû oublier…"', emoji: '❓', answer: 'Probabilité au passé' },
        { clue: '"J\'ai lu ce livre…"', emoji: '📚', answer: 'Passé composé' },
      ],
    },
  ],
  B2: [
    {
      id: 'enigmes-abstraites-b2-1',
      title: 'Énigmes abstraites I',
      finalTask: "Choisis une énigme et écris ta propre version sur un thème différent.",
      finalExamples: [
        "Je suis invisible mais tout le monde me sent. Je peux unir ou diviser. → L'amour",
        "Je suis donné à la naissance mais je change selon tes actes. → Le nom / la réputation",
      ],
      questions: [
        { clue: "Je parle sans bouche,\nj'entends sans oreilles,\nje voyage partout sans me déplacer.\nQui suis-je ?", emoji: '🔊', answer: "L'écho", task: "Explique en 2-3 phrases pourquoi cette réponse est correcte. Utilise parce que et une proposition relative (qui / que)." },
        { clue: "Je suis souvent donnée,\nparfois perdue,\net difficile à reconstruire une fois brisée.\nQui suis-je ?", emoji: '🤝', answer: 'La confiance', task: "Donne un exemple concret où la confiance est importante. Utilise le conditionnel (serait / pourrait)." },
        { clue: "Je grandis quand tu me partages,\nje deviens lourd quand tu me gardes,\net je disparais quand tu me révèles.\nQui suis-je ?", emoji: '🤫', answer: 'Un secret', task: "Explique si tu penses qu'il est toujours bon de garder un secret." },
        { clue: "Plus j'ai de dents, moins je mords,\nplus je tourne, plus j'use le temps.\nQui suis-je ?", emoji: '⚙️', answer: 'Un engrenage / un peigne', task: "Explique les deux interprétations possibles de cette énigme." },
        { clue: "Je peux te porter sans te toucher,\nte détruire sans te blesser,\nou t'inspirer à changer.\nQui suis-je ?", emoji: '💡', answer: 'Une idée', task: "Donne un exemple d'idée qui a changé ta façon de penser." },
        { clue: "Je précède tout le monde, même les rois,\nmais je n'avance jamais d'un pas.\nQui suis-je ?", emoji: '👤', answer: "L'ombre", task: "Explique le lien entre l'ombre et la notion de précéder. Utilise une comparaison." },
        { clue: "Je suis invisible mais tout le monde me sent,\nje peux apaiser ou détruire,\net je change selon tes pensées.\nQui suis-je ?", emoji: '🌤️', answer: "L'humeur", task: "Décris comment ton humeur peut influencer tes relations avec les autres." },
        { clue: "Je n'existe que si tu me regardes,\nj'apparais dans les yeux, mais aussi dans l'âme.\nQui suis-je ?", emoji: '🪞', answer: 'Le reflet', task: "Compare le reflet physique et le reflet métaphorique (de l'âme)." },
        { clue: "Toujours devant toi,\nparfois derrière toi,\nmais jamais en dehors de ton chemin.\nQui suis-je ?", emoji: '🔮', answer: "L'avenir", task: "Explique pourquoi l'avenir est toujours devant nous mais jamais atteignable. Utilise une expression de temps." },
        { clue: "Je coûte cher quand je manque,\nje vaux peu quand j'abonde,\nmais personne ne peut vivre sans moi.\nQui suis-je ?", emoji: '⏳', answer: 'Le temps', task: "Donne un exemple concret où le temps a une valeur inestimable." },
      ],
    },
    {
      id: 'enigmes-abstraites-b2-2',
      title: 'Énigmes abstraites II',
      finalTask: "Choisis deux réponses de ce set et compare-les en 3 phrases.",
      finalExamples: [
        "L'instinct et la lune sont tous les deux liés à la nuit. L'un guide nos décisions, l'autre éclaire le ciel.",
        "Un mot et un livre sont liés : un livre est composé de mots, mais un seul mot peut changer un discours.",
      ],
      questions: [
        { clue: "On me suit parfois les yeux fermés,\nje peux te tromper ou te guider,\net je disparais quand tu doutes.\nQui suis-je ?", emoji: '🧭', answer: "L'instinct", task: "Explique la différence entre suivre son instinct et réfléchir avant d'agir." },
        { clue: "Je suis léger comme l'air,\nmais je peux briser une amitié,\net un seul de moi peut changer tout un discours.\nQui suis-je ?", emoji: '💬', answer: 'Un mot', task: "Donne un exemple d'un mot qui a changé une situation. Utilise le passé composé." },
        { clue: "Je marche sans pieds,\nj'éclaire sans être une lampe,\net je disparais chaque matin.\nQui suis-je ?", emoji: '🌙', answer: 'La lune', task: "Décris la lune en utilisant au moins deux métaphores." },
        { clue: "Je peux dormir pendant des siècles,\npuis me réveiller en un instant,\net provoquer une catastrophe.\nQui suis-je ?", emoji: '🌋', answer: 'Un volcan', task: "Compare un volcan à une émotion humaine. Utilise comme ou tel que." },
        { clue: "Je suis là quand tu arrives,\nje reste quand tu pars,\nje disparais quand tu me renies.\nQui suis-je ?", emoji: '📛', answer: 'Le nom / la réputation', task: "Explique pourquoi la réputation est fragile en donnant un exemple." },
        { clue: "Je suis parfois court, parfois long,\nje peux être dur ou tendre,\net je fais souvent peur alors que je ne suis qu'un passage.\nQui suis-je ?", emoji: '🤫', answer: 'Le silence', task: "Analyse les différentes formes de silence (positif, négatif, gênant)." },
        { clue: "Je ne parle pas mais j'explique tout,\nje ne vis pas mais j'ai une histoire,\net je reste silencieux même quand je crie la vérité.\nQui suis-je ?", emoji: '📖', answer: 'Un livre', task: "Explique comment un livre peut « crier la vérité » tout en restant silencieux." },
        { clue: "Je suis plus dangereux quand je suis petit,\nje peux voler sans ailes,\net je change de couleur pour montrer ma colère.\nQui suis-je ?", emoji: '🔥', answer: 'Une étincelle', task: "Donne un exemple d'étincelle au sens figuré. Utilise cela peut provoquer…" },
        { clue: "Je cours sans jambes,\nje chante sans voix,\net je voyage jusqu'à la mer.\nQui suis-je ?", emoji: '🏞️', answer: 'Une rivière', task: "Compare la rivière à un aspect de la vie humaine en 2-3 phrases." },
        { clue: "Je suis ton premier maître,\nton dernier refuge,\net la seule chose que tu peux perdre sans la quitter.\nQui suis-je ?", emoji: '🏠', answer: 'La maison (ou la famille)', task: "Explique les deux interprétations possibles : maison et famille." },
      ],
    },
    {
      id: 'enigmes-abstraites-b2-3',
      title: 'Énigmes abstraites III',
      finalTask: "Écris une réflexion personnelle sur le thème commun de ce set.",
      finalExamples: [
        "Ce set parle des liens entre les idées. Chaque concept — le pardon, l'ironie, la loi — montre que le langage structure notre pensée.",
        "Les mots, les liens et les lois sont tous des outils pour organiser la société.",
      ],
      questions: [
        { clue: "Je répare les cœurs cassés sans outil,\nje prends parfois du temps, parfois une parole.\nQui suis-je ?", emoji: '💝', answer: 'Le pardon', task: "Explique pourquoi le pardon est difficile mais nécessaire. Utilise bien que + subjonctif." },
        { clue: "Je suis entouré de couleurs en automne,\nje perds mes habits quand vient l'hiver,\net je reviens toujours au printemps.\nQui suis-je ?", emoji: '🌳', answer: 'Un arbre', task: "Compare le cycle d'un arbre à la vie humaine." },
        { clue: "Je lie des idées entre elles,\nsans moi, les phrases seraient des îles.\nQui suis-je ?", emoji: '🔗', answer: 'Une conjonction / un lien logique', task: "Donne 3 exemples de liens logiques et utilise-les dans des phrases." },
        { clue: "Je prends différentes formes selon le contexte,\nje peux être subtil ou explosif,\net souvent je révèle la vérité.\nQui suis-je ?", emoji: '🎭', answer: "L'ironie", task: "Donne un exemple d'ironie dans la vie quotidienne." },
        { clue: "Je ne suis pas un roi, mais j'ai souvent couronne,\nje tombe toujours mais je ne me blesse jamais.\nQui suis-je ?", emoji: '💧', answer: "Une goutte d'eau (ou la pluie)", task: "Explique pourquoi les petites choses peuvent avoir de grandes conséquences." },
        { clue: "Plus tu me retiens, moins je suis utile ;\nplus tu me donnes, plus je deviens grand.\nQui suis-je ?", emoji: '❤️', answer: "L'amour / la confiance", task: "Compare l'amour et la confiance : lequel est le plus fragile ? Justifie." },
        { clue: "Je suis l'art de prévoir sans être devin,\nje rassemble des preuves pour imaginer demain.\nQui suis-je ?", emoji: '📊', answer: 'La prévision / la prospective', task: "Explique la différence entre prévoir et deviner." },
        { clue: "Je peux être court dans les mains d'un poète,\nlong et laborieux pour un historien,\nje construis le sens avec des détails.\nQui suis-je ?", emoji: '📝', answer: 'Le récit / la narration', task: "Compare un récit littéraire et un récit historique en 2 phrases." },
        { clue: "On me brandit pour calmer une foule,\nparfois on me brise pour provoquer un changement.\nQui suis-je ?", emoji: '⚖️', answer: 'La loi / la règle', task: "Explique pourquoi certaines lois doivent évoluer avec la société." },
        { clue: "Je vis dans les pages oubliées,\nje rends les souvenirs plus clairs ou plus doux.\nQui suis-je ?", emoji: '📓', answer: 'La mémoire écrite / le journal intime', task: "Explique l'importance d'écrire ses souvenirs. Utilise grâce à." },
      ],
    },
    {
      id: 'enigmes-abstraites-b2-4',
      title: 'Énigmes abstraites IV',
      finalTask: "Choisis le concept qui te touche le plus et explique pourquoi en 3-4 phrases.",
      finalExamples: [
        "Le concept qui me touche le plus est le voyage, car il représente la découverte et le changement.",
        "Je choisis le pouvoir parce qu'il peut transformer les sociétés.",
      ],
      questions: [
        { clue: "Je suis le bruit de l'absence,\non me remplit avec des mots ou des actes.\nQui suis-je ?", emoji: '🔇', answer: 'Le silence', task: "Distingue le silence positif du silence négatif avec des exemples." },
        { clue: "Je suis la distance entre l'idée et l'action,\nje demande courage et parfois patience.\nQui suis-je ?", emoji: '🚀', answer: 'Le passage à l\'acte / la décision', task: "Donne un exemple personnel de passage à l'acte." },
        { clue: "Je suis minuscule mais je peux tout changer,\non m'ignore souvent jusqu'à ma conséquence.\nQui suis-je ?", emoji: '🔄', answer: 'Une habitude', task: "Décris une habitude qui peut transformer une vie." },
        { clue: "Je suis une promesse sans date,\non me donne souvent en début d'année.\nQui suis-je ?", emoji: '📅', answer: 'Une bonne résolution', task: "Pourquoi les résolutions échouent-elles souvent ? Donne ton analyse." },
        { clue: "Je peux être liquide, solide ou gazeux,\nje suis essentiel mais parfois destructeur.\nQui suis-je ?", emoji: '💧', answer: "L'eau", task: "Explique comment l'eau peut être à la fois essentielle et destructrice." },
        { clue: "Je représente la fin d'un chapitre et le début d'un autre,\non me fête parfois, on me redoute parfois.\nQui suis-je ?", emoji: '🔀', answer: 'Une transition / un changement', task: "Décris une transition importante dans ta vie. Utilise avant / après." },
        { clue: "Je peux être court et cruel, long et doux,\nje marque les étapes importantes de la vie.\nQui suis-je ?", emoji: '🗺️', answer: 'Le voyage', task: "Explique la différence entre voyager et se déplacer." },
        { clue: "Je suis né d'un besoin et je meurs d'un excès,\nje peux unir des équipes ou diviser des peuples.\nQui suis-je ?", emoji: '👑', answer: 'Le pouvoir', task: "Analyse les dangers du pouvoir en 2-3 phrases." },
        { clue: "Je suis l'art de dire moins pour faire entendre plus,\non me trouve souvent dans la poésie et la publicité.\nQui suis-je ?", emoji: '✍️', answer: "La concision / l'ellipse", task: "Donne un exemple de phrase concise mais puissante." },
        { clue: "Je suis le miroir du temps : on me garde, on me perd, on me regrette,\nparfois je guéris, parfois je ronge.\nQui suis-je ?", emoji: '🕰️', answer: 'Le souvenir / la nostalgie', task: "Explique la différence entre un souvenir et la nostalgie." },
      ],
    },
    {
      id: 'enigmes-abstraites-b2-5',
      title: 'Énigmes abstraites V',
      finalTask: "Écris ta propre énigme abstraite sur un concept de ton choix (3-4 lignes).",
      finalExamples: [
        "Je suis invisible mais essentiel, je lie les peuples et les générations. → La langue",
        "Je suis fragile comme le verre, précieux comme l'or, et je se construit chaque jour. → La réputation",
      ],
      questions: [
        { clue: "Je peux être partagé sans me diviser,\nje grandis quand on m'écoute et diminue quand on m'ignore.\nQui suis-je ?", emoji: '👂', answer: "L'attention", task: "Explique pourquoi l'attention est un cadeau dans les relations humaines." },
        { clue: "Je suis un pont entre deux personnes, fait de mots et d'actes,\nquand je manque, la distance s'agrandit.\nQui suis-je ?", emoji: '🌉', answer: 'La confiance (relationnelle)', task: "Donne un exemple concret de confiance dans une relation." },
        { clue: "Je suis léger comme une promesse,\nmais mon poids dépend du sens qu'on me donne.\nQui suis-je ?", emoji: '📜', answer: 'Un engagement', task: "Compare une promesse et un engagement : quelle est la différence ?" },
        { clue: "Je suis une faux qui ne coupe pas les corps mais le temps,\nje marque les anniversaires et les douleurs.\nQui suis-je ?", emoji: '⏳', answer: "Le vieillissement / l'âge", task: "Exprime ton opinion sur le vieillissement en utilisant le conditionnel." },
        { clue: "Je suis une porte que l'on ouvre avec courage,\nparfois je m'appelle « première fois ».\nQui suis-je ?", emoji: '🚪', answer: "L'expérience nouvelle / l'initiation", task: "Raconte une « première fois » qui t'a marqué." },
        { clue: "Je suis une lumière qui révèle et parfois éblouit,\nje peux être vérité ou simple opinion forte.\nQui suis-je ?", emoji: '💡', answer: "L'information / la vérité perçue", task: "Explique la différence entre information et vérité." },
        { clue: "Je nais d'une idée et deviens culture quand on me partage,\nje peux changer les habitudes d'un peuple.\nQui suis-je ?", emoji: '🌍', answer: 'Une pratique sociale / une coutume', task: "Donne un exemple de coutume qui a évolué avec le temps." },
        { clue: "Je suis le lieu où l'on garde les traces d'un passé commun,\non m'entretient pour que les générations se souviennent.\nQui suis-je ?", emoji: '🏛️', answer: 'La mémoire collective / le patrimoine', task: "Explique pourquoi le patrimoine est important pour une société." },
        { clue: "Je suis parfois vérité, parfois illusion,\non me vend pour convaincre, on me critique pour manipuler.\nQui suis-je ?", emoji: '📰', answer: 'La propagande / la rhétorique', task: "Distingue la rhétorique de la manipulation en 2-3 phrases." },
        { clue: "Je suis ce que l'on vise quand on souhaite progresser,\nje me mesure, je se fixe et parfois je se dépasse.\nQui suis-je ?", emoji: '🎯', answer: 'Un objectif / un but', task: "Décris ton objectif le plus important et comment tu comptes l'atteindre." },
      ],
    },
  ],
};
